/**
 * The Studio's terminal latch (Plan 2B obligation #1).
 *
 * onSessionExpired can legitimately fire more than once (once per request
 * under server-side revocation) — this module absorbs that into a single
 * one-way transition so the UI latches exactly once and every post-expiry
 * render sees the same answer. Without this latch, every subsequent request
 * would burn a full mint→401→refresh→retry cycle.
 */
let latched = false;
const listeners = new Set<() => void>();

export function latchSessionExpired(): void {
  if (latched) return;
  latched = true;
  listeners.forEach((cb) => cb());
}

export function isSessionExpired(): boolean {
  return latched;
}

export function subscribeSessionExpired(cb: () => void): () => void {
  listeners.add(cb);
  if (latched) cb();
  return () => {
    listeners.delete(cb);
  };
}

/** Test seam only. */
export function resetSessionExpiryForTest(): void {
  latched = false;
  listeners.clear();
}
